import React, {useEffect, useState} from 'react'
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import PageHeader from '../../../components/pageHeader/PageHeader';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import PageButtons from '../../../components/pageComponents/PageButtons';
import {NavDropdown} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';
import {
    aprobarFaltasAPI, declararNoTengoFaltasQueReportarAPI,
    DescargarReporteFaltasExcelAPI,
    getAllCargosAPI, getAllDepartamentosAPI,
    getAllEstadosAPI, getAllSedesAPI, getAllTiposFaltaAPI, getListaFaltasAPI,
    getPeriodosForFiltroListarFaltasAPI
} from '../../../consumers/backendApisUrls';
import styled from "styled-components";
import {useGetRequest} from "../../../hooks/useGetRequest/useGetRequest";
import {
    initialAllOptionPromises,
    jsonNoEstaVacio,
    updateFiltersWithExtraData
} from "../../../helper/utils";
import PageWrapper from "../../../components/pageComponents/PageWrapper";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import useDidMountEffect from "../../../hooks/useDidMountEffect/useDidMountEffect";
import Select from "react-select";
import {
    useGenerarDescargarEliminarArchivo
} from "../../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo";
import TableFaltas from "./TableFaltas";
import RegistrarFalta from "./modales/RegistrarFalta";
import DeclararNoTengoFaltas from "./modales/DeclararNoTengoFaltas";
import CustomAlert from "../../../components/alerts/CustomAlert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NivelesAprobacion from "../../registroMaternidad/modales/NivelesAprobacion/NivelesAprobacion";
import TiposLicencia from "../../registroMaternidad/modales/TiposLicencia/TiposLicencia";

const INIT_KEYS = {
    IdsTipoFaltas: "IdsTipoFaltas",
    IdsEstadosEmpleado: "IdsEstadosEmpleado",
    IdsDepartamentos: "IdsDepartamentos",
    IdsCargos: "IdsCargos",
    IdsSedes: "IdsSedes",
    IdsEstados: "IdsEstados",
};

const AdminGestionDeFaltas = () => {
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);
    const [idsFaltasConCheck, setIdsFaltasConCheck] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);

    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const [allPeriodos, setallPeriodos] = useState([]);
    const [selectedPeriodo, setSelectedPeriodo] = useState();

    const [downloaAndDeletedReport] = useGenerarDescargarEliminarArchivo();

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllTiposFaltaAPI()),
            response,
            executeGet(getAllDepartamentosAPI()),
            executeGet(getAllCargosAPI()),
            executeGet(getAllSedesAPI()),
            response
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await manageSearch();
            await getAllPeriodos();
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = getListaFaltasAPI();
        const payload = getPayload();
        await executeManagePost(api, payload, successManageSearchCallback);
        setIdsFaltasConCheck([]);
        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdFaltaPeriodo: selectedPeriodo?.value,
            ...formValues.selectedFilters
        }
    }

    const getAllPeriodos = async () => {
        const api = getPeriodosForFiltroListarFaltasAPI();
        await executeManageGet(api, (res) => successGetAllPeriodosCallback(res), false);
    }

    const successGetAllPeriodosCallback = ({data}) => {
        const items = data.map(o => ({value: o.IdFaltaPeriodo, label: o.Nombre}));
        setallPeriodos(items);
        if (items.length > 0) {
            setSelectedPeriodo(items[0]);
        }
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    const handleDescargar = async () => {
        const api = DescargarReporteFaltasExcelAPI();
        const payload = getPayload();
        await downloaAndDeletedReport(api, payload);
    }

    const aprobarMasivo = async () => {
        const api = aprobarFaltasAPI();
        const payload = {
            IdFaltas: idsFaltasConCheck
        }
        await executeManagePost(api, payload, () => {
            manageSearch()
        });
    }

    const noDeclaroFaltas = async () => {
        const api = declararNoTengoFaltasQueReportarAPI();
        const payload = {}
        await executeManagePost(api, payload, () => {
            manageSearch()
        });
    }

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();
    }, [])

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        manageSearch();
    }, [selectedPeriodo?.value])

    return (

        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Gestión de Faltas"/>

            {formValues.ExtraData.SeHaDeclaradoSinFaltasParaSedeEnPeriodoVigente === true &&
                <CustomAlert variant={"warning"}>
                    <p className="ficha-secciones-title-text font-gothan-light">
                        <span className="mr-3">
                            La Sede <strong>{formValues.ExtraData.NoTengoFaltasQueReportar_SedeAReportar}</strong> fue declarada sin faltas para el periodo <strong>{formValues.ExtraData.NoTengoFaltasQueReportar_PeriodoAReportar}</strong>
                        </span>

                        <FontAwesomeIcon
                            icon="info-circle"
                            transform="left-9"
                            className="hand-pointer"
                        />
                    </p>

                </CustomAlert>
            }

            <SelectPeriodos items={allPeriodos} selectedItem={selectedPeriodo} setSelectedItem={setSelectedPeriodo}/>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <div className="d-flex">
                        <PageButtons>
                            {formValues.ExtraData.PuedeRegistrar === true &&
                                <button
                                    type="button"
                                    className="generic-button-buscador"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: RegistrarFalta,
                                            data: {isAdmin: false, idEmpleado: 0}
                                        })
                                    }
                                >
                                    Registrar Falta
                                </button>
                            }


                            <NavDropdown id={"navDropdown-admiGestionDeBeneficios"}
                                         className="generic-button-dropdown font-gothan-light"
                                         title={
                                             <span className="generic-button-dropdown-title">Acciones</span>
                                         }>
                                {idsFaltasConCheck.length > 0 &&
                                    <NavDropdown.Item onClick={aprobarMasivo}>Aprobar Masivo</NavDropdown.Item>
                                }

                                <NavDropdown.Item onClick={handleDescargar}>Descargar Reporte</NavDropdown.Item>

                                {formValues.ExtraData.PuedeDeclararNoTengoFaltasQueReportar === true &&
                                    <NavDropdown.Item onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: DeclararNoTengoFaltas,
                                            data: {extraData: formValues?.ExtraData, noDeclaroFaltas}
                                        })
                                    }>Declarar sin faltas
                                    </NavDropdown.Item>
                                }
                            </NavDropdown>

                        </PageButtons>

                        {formValues.ExtraData.PuedeConfigurarPeriodos === true &&
                            <PageButtons>
                                <NavDropdown id={"navDropdown-configuracion-faltas"}
                                             className=""
                                             title={<span className="align-items-center p-2 ml-2"
                                                          style={{backgroundColor: 'gray', borderRadius: '50%'}}
                                                          onClick={() => {
                                                          }}
                                             >


                                                 <FontAwesomeIcon icon='cog' size="lg" className="hand-pointer white"
                                                                  style={{color: 'white'}}
                                                                  title="Configurar"/>
                                                 </span>}>
                                    <Link
                                        to="/gestionDeFaltas/listarPeriodosFaltas"
                                        className="dropdown-item">
                                        Configurar Periodos
                                    </Link>
                                </NavDropdown>
                            </PageButtons>
                        }
                    </div>

                </ButtonsWrapper>
            </SearchContainer>


            <TableFaltas
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                idsFaltasConCheck={idsFaltasConCheck}
                setIdsFaltasConCheck={setIdsFaltasConCheck}
                manageSearch={manageSearch}
                fromAdminPage={true}
            />
        </PageWrapper>

    );
};

export default AdminGestionDeFaltas;

const SelectPeriodos = ({items, selectedItem, setSelectedItem}) => (
    <div className='col-sm-4 mt-2 ml-2'>
        <Select
            placeholder="Seleccionar Periodo"
            options={items}
            value={selectedItem}
            onChange={(res) => setSelectedItem({...res})}
        />
    </div>
)

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;
